import {useOrganization} from "crqlar-react-common/dist/state/auth.reducer";
import {useTranslation} from "react-i18next";
import type {InsightsLoading} from "../../kit/insightsLoading";
import type {InsightRankedGuestV4} from "../../models/crm-v4";
import RankedGuestTable from "./RankedGuestTable";
import {useRankedGuestTableActions} from "./useRankedGuestTableActions";

interface TopSpendersTableProps {
    rows: InsightRankedGuestV4[];
    comparisonRows?: InsightRankedGuestV4[];
    loading?: InsightsLoading;
}

export function TopSpendersTable({rows, comparisonRows, loading}: TopSpendersTableProps) {
    const {t, i18n} = useTranslation();
    const currency = useOrganization()?.currencyCode || "EUR";
    const currencyFormatter = new Intl.NumberFormat(i18n.resolvedLanguage || i18n.language, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
    });
    const actions = useRankedGuestTableActions("TOP_SPENDERS");

    return (
        <RankedGuestTable
            title={t("Top spenders")}
            hint={t("Guests arriving in the selected period, ranked by their lifetime total spend.")}
            valueLabel={t("Lifetime spend")}
            rows={rows}
            comparisonRows={comparisonRows}
            loading={loading}
            formatValue={value => currencyFormatter.format(value)}
            {...actions}
        />
    );
}

export default TopSpendersTable;
